import { create } from "zustand";

import { FilterModeOption } from "../../../../Pages/CloudAnalytics/allocations/types";

const useFilterStore = create<{
  mode: FilterModeOption;
  inputValue: string;
  selectedValues: string[];
  setSelectedValues: (selectedValues: string[]) => void;
  filtersStateChanged: boolean;
  filters: string[];
  setFilters: (input: string[]) => void;
  setMode: (mode: FilterModeOption) => void;
  setInputValue: (input: string) => void;
  setFiltersStateChanged: (state: boolean) => void;
  resetFields: () => void;
}>()((set) => ({
  mode: FilterModeOption.IS,
  inputValue: "",
  filtersStateChanged: false,
  filters: [],
  setSelectedValues: (selectedValues: string[]) => {
    set({ selectedValues });
  },
  selectedValues: [],
  setFiltersStateChanged: (state: boolean) => {
    set({ filtersStateChanged: state });
  },
  setInputValue: (input: string) => {
    set({ inputValue: input });
  },
  setFilters: (input: string[]) => {
    set({ filters: input });
  },
  setMode: (mode) => {
    set({ mode });
  },
  resetFields: () => {
    set(() => ({
      mode: FilterModeOption.IS,
      inputValue: "",
      selectedValues: [],
      filtersStateChanged: false,
    }));
  },
}));

export default useFilterStore;
